import {Tooltip} from 'platform/components';
import {Text} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import {CellRendererProps} from '../../types/CellRendererProps';
import {CellStyle} from '../../types/CellStyle';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getNumericCellClassName} from '../../utils/getCellClassName';
import {getStylesToRender} from '../../utils/getStylesToRender';
import {getTooltipProps} from '../../utils/getTooltipProps';
import {EmptyCellValue} from '../EmptyCellValue/EmptyCellValue';

type MoneyValue = {amount: number; currency: string} | null;

type MoneyCellRendererProps = CellRendererProps<MoneyValue> & {
  getTooltipProps?: TooltipGetter;
};

export function MoneyCellRenderer(props: MoneyCellRendererProps) {
  const className = getNumericCellClassName(props.isWrap);
  const formatCurrency = useFormatCurrency();
  const cellStyles = getStylesToRender<CellStyle>(props);
  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  if (isNil(props.value)) {
    return <EmptyCellValue emptyCellValue={props.emptyCellValue} isWrap={props.isWrap} isNumeric />;
  }

  const decimalPlaces =
    typeof props.column.rendererParams?.decimalPlaces === 'number'
      ? props.column.rendererParams.decimalPlaces
      : 2;
  const cellValue = formatCurrency(props.value.amount, props.value.currency, decimalPlaces);

  return (
    <Tooltip {...tooltipProps} label={cellValue ?? undefined}>
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!props.isWrap} size="small">
          {cellValue}
        </Text>
      </div>
    </Tooltip>
  );
}
